import { createAsyncThunk } from '@reduxjs/toolkit';
import * as skillEmailService from './email-api';
import { IEmailPayload } from './email-interface';
import type { IRootState } from '../../app/store';

export const sendPatientEducationEmail = createAsyncThunk(
    'Email/sendPatientEducationEmail',
    async (payload: IEmailPayload, { rejectWithValue, getState }) => {
        try {
            const { isWhitelisted } = (getState() as IRootState)
                .referentialAccess;
            const response = await skillEmailService.sendPatientEducationEmail(
                payload,
                isWhitelisted
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
